// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 81029) return "static/chunks/" + chunkId + "-876d5998f93828df.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"10343":"6edf0643","52084":"9b0008ae","60277":"54a60aa6","75004":"70e0d97a"}[chunkId] || chunkId) + "." + {"10343":"c3a9fe7d54ec5b3f","16233":"ebd07e5c42c72b09","38501":"eaaba71ed210902b","45949":"e635698bb92b9553","52084":"5e95fc3183fb5731","60277":"d2e980792609ee56","75004":"52281815cc88eccf"}[chunkId] + ".js";
};